import React from 'react';
import { Typography, ArrowIcon } from 'fronton-react';
import {
  controlStyles,
  iconOnlyControlStyles,
  invertedIconOnlyControlStyles,
  seeMoreCardStyles,
  seeMoreCardSponsoredStyles,
  sponsoredSeeMoreCardStylesMedia,
  SeeMoreCaption,
  seeMoreCaptionSponsoredStyles,
} from './styles';
import { cx } from 'linaria';

type SeeMoreButtonProps = {
  isSponsored?: boolean;
  seeAllButtonCaption: string;
  seeMoreLinkActual: string;
  seeMoreLinkOnClickHandler: () => void;
};

export const SeeMoreButton: React.FC<SeeMoreButtonProps> = ({
  isSponsored = false,
  seeAllButtonCaption,
  seeMoreLinkActual,
  seeMoreLinkOnClickHandler,
}) => (
  <a
    href={seeMoreLinkActual}
    onClick={seeMoreLinkOnClickHandler}
    className={cx(
      seeMoreCardStyles,
      isSponsored && seeMoreCardSponsoredStyles,
      sponsoredSeeMoreCardStylesMedia,
    )}
  >
    <span className={cx(iconOnlyControlStyles, invertedIconOnlyControlStyles, controlStyles)} aria-hidden>
      <ArrowIcon direction="right" />
    </span>
    <SeeMoreCaption>
      <Typography
        variant="m"
        size="body_short"
        color="text-primary"
        className={cx(isSponsored && seeMoreCaptionSponsoredStyles)}
      >
        {seeAllButtonCaption}
      </Typography>
    </SeeMoreCaption>
  </a>
);
